import { Navigate } from 'react-router';

import { ERROR_PATH, ROOT_PATH } from 'app/shared/consts';
import { useOpenParams } from 'app/shared/hooks/use-open-params';
import { useAnalytics } from 'app/shared/hooks/use-analytics-hook';

export const AppRoot = (): JSX.Element => {
  const { buildingUuid } = useOpenParams();
  useAnalytics();

  // buildingUuid comes from the query params (useOpenParams), not the path.
  if (!buildingUuid) {
    return <Navigate to={ERROR_PATH} />;
  }

  return <Navigate to={ROOT_PATH} />;
};
